import { configureStore } from '@reduxjs/toolkit';
import appointmentReducer from '../features/appointments/appointmentsSlice';
import todoReducer from '../features/todos/todosSlice';
import patientReducer from '../features/patients/patientsSlice';
import invoiceReducer from '../features/invoices/invoicesSlice';
import vaccinationReducer from '../features/vaccinations/vaccinationsSlice';
import timeSlotReducer from '../features/timeslots/timeslotsSlice';
import consultationReducer from '../features/consultation/consultationSlice';
import userReducer from '../features/user/userSlice';
import templatesReducer from '../features/templates/templatesSlice';

export const store = configureStore({
    reducer: {
        appointments: appointmentReducer,
        todos: todoReducer,
        patients: patientReducer,
        invoices: invoiceReducer,
        vaccinations: vaccinationReducer,
        timeslots: timeSlotReducer,
        consultation: consultationReducer,
        user: userReducer,
        templates: templatesReducer
    }
})